var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { QuestionTypeName } from '../../classes/learnware/LearnwareEnums';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { CorrectWrongStore } from './modules/CorrectWrongStore';
import { alias, disgardOldValue, object } from '../../utils/serializr/serializr';
import { CorrectWrongScore } from './modules/CorrectWrongScore';
import { withInit } from '../../utils/serializr/schema/middle/withInit';
import { primitive } from '../../utils/serializr/schema/inner/primitive';
import { Question } from '../../classes/question/Question';
import { MultipleChoiceAnsweringFeedback } from '../MultipleChoice/modules/MultipleChoiceAnsweringFeedback';
import { Choice } from '../Choice/Choice';
import { editable } from '../../utils/mobx/decorators/editable';
export class QuestionCorrectWrong extends Choice {
    questionType = QuestionTypeName.CorrectWrong;
    isShuffableQuestionType = false;
    get options() {
        return super.options;
    }
    get shuffledOptions() {
        return super.shuffledOptions;
    }
    get answeringFeedback() {
        return new MultipleChoiceAnsweringFeedback(this);
    }
    get multipleChoiceStore() {
        return this.choiceStore;
    }
    get questionScore() {
        return new CorrectWrongScore(this);
    }
    MAX_OPTIONS = 2;
    static get serializeInfo() {
        return {
            extends: Question.serializeInfo,
            props: {
                questionType: withInit(primitive, QuestionTypeName.CorrectWrong),
                choiceStore: alias('questionTypeStore', withInit(object(CorrectWrongStore), {})),
                textBasis: alias('text', disgardOldValue(primitive)),
            },
        };
    }
}
__decorate([
    editable()
], QuestionCorrectWrong.prototype, "questionType", void 0);
__decorate([
    memoize
], QuestionCorrectWrong.prototype, "answeringFeedback", null);
__decorate([
    memoize
], QuestionCorrectWrong.prototype, "questionScore", null);
__decorate([
    memoize
], QuestionCorrectWrong, "serializeInfo", null);
